<template>
  <div>
    <div class="vx-row mb-12">
      <vs-button
        v-on:click="receive()"
        icon="done"
        color="primary"
        style="margin-bottom: 15px"
      >
        Receive
      </vs-button>
    </div>

    <div class="vx-row mb-12">
      <div
        v-bind:class="[
          detail ? detailShow + ' vertical-divider' : '',
          detailHide,
        ]"
      >
        <data-table
          :responseData="responseData"
          :propsParams="params"
          :header="header"
          @reloadDataFromChild="reloadData"
        >
          <template slot="thead">
            <vs-checkbox
                color="success"
                v-on:click="addAllValidate()"
                v-model="validateAll"
              >
                Check All
              </vs-checkbox>
          </template>
          <template slot="tbody">
            <vs-tr :key="indextr" v-for="(tr, indextr) in responseData.payment">
              <vs-td>
                <vs-checkbox
                  color="success"
                  :checked="validate.includes(tr.ID)"
                  v-on:click="addValidate(tr.ID)"
                >
                </vs-checkbox>
              </vs-td>
              <vs-td>
                <template>
                  <vx-tooltip text="View Collection">
                    <vs-button
                      color="primary"
                      type="line"
                      icon-pack="feather"
                      v-on:click="handleView(tr)"
                      icon="icon-eye"
                    />
                  </vx-tooltip>
                </template>
              </vs-td>
              <vs-td>
                {{ tr.Code }}
              </vs-td>
              <vs-td>
                {{ tr.NameUserFrom }}
              </vs-td>
              <vs-td>
                {{ priceFormat(tr.Total) }}
              </vs-td>
            </vs-tr>
          </template>
        </data-table>
      </div>
      <transition name="detail-fade">
        <div
          v-if="detail"
          v-bind:class="[
            detail ? ' nonfixed vx-col md:w-1/2 w-full mb-base' : '',
            detailHide,
          ]"
        >
          <div>
            <vs-col
              style="padding-bottom: 8px"
              vs-offset="8"
              vs-type="flex"
              vs-justify="rigth"
              vs-align="rigth"
              vs-w="4"
            >
              <vs-button
                size="small"
                v-on:click="closeDetail"
                color="grey"
                icon-pack="feather"
                icon="icon-x-square"
                >Close</vs-button
              >
            </vs-col>
            <form-view :selected="selectedData" />
          </div>
        </div>
      </transition>
    </div>
  </div>
</template>
<script>
import { collectCashLog, changeStatusCashLog } from "../../../../services/api/invoice";
import formView from "./form_view.vue";
export default {
  props: {
    selected: Object,
    option: Object,
  },
  components: {
    "form-view": formView,
  },
  data() {
    return {
      params: {
        search: "",
        length: 10,
        page: 1,
        order: "desc",
        sort: "id",
      },
      header: [
        {
          text: "Action",
          sortable: false,
          // width: '5%'
        },
        {
          text: "Code Collect",
          value: "code",
          // width: '5%'
        },
        {
          text: "Name",
          value: "name_user_from",
        },
        {
          text: "Amount",
          value: "total",
        },
      ],
      responseData: {},
      detailShow: "vx-col md:w-1/2 w-full mb-base",
      detailHide: "core vx-col md:w-1/1 w-full mb-base",
      detail: false,
      validate: [],
      validateAll: false,
      selectedData: {},
    };
  },
  computed: {},
  watch: {},
  mounted() {
    this.reloadData(this.params);

    // this.getData();
    // this.page(1);
    // this.dataId = this.data[0].id
  },
  methods: {
    receive() {
      this.$vs.loading();
      console.log(this.validate)
      
        const params = {
          ID: this.validate[0],
          status: 1,
        }
        const post = this.changeStatus(params, 0)
        
      
    },
    changeStatus(params, now) {
      return new Promise(resolve => {
        const cashLog = changeStatusCashLog(params)
        cashLog.then(r => {
          const next = parseInt(now) + parseInt(1)

          if (next <  this.validate.length) {
            const params = {
              ID: this.validate[next],
              status: 1,
            }
            this.changeStatus(params, next)
          } else {
            this.reloadData(this.params)
            this.validate = []
            this.validateAll = false
            this.$vs.loading.close();
          }
        })
        resolve(true)
      })
    },
    handleView(selected) {
      this.detail = true;
      this.selectedData = selected
    },
    addValidate(ID) {
      console.log(this.validate.length);
      if (this.validate.includes(ID)) {
        this.validate.splice(this.validate.indexOf(ID), 1);
      } else {
        this.validate.push(ID);
      }
    },
    addAllValidate() {
      console.log(this.data, this.validateAll);
      if (this.validateAll == false) {
        for (var i in this.data) {
          if (!this.validate.includes(this.data[i].ID)) {
            this.validate.push(this.data[i].ID);
          }
        }
      } else {
        this.validate = [];
      }
    },
    reloadData(params) {
      this.params = params;
      console.log(params);
      this.$vs.loading();

      const dataTable = collectCashLog(params);
      dataTable.then((r) => {
        console.log(r);
        if (r.code == 500) {
          this.$vs.loading.close();
        } else if (r.code == 200) {
          this.$vs.loading.close();
          this.data = r.data.payment;
          this.responseData = r.data;
          this.responseData.length = r.data.payment.length;
          this.checkedAll = false;
        } else {
          this.$vs.loading.close();
        }
      });
    },
    closeDetail(params = false) {
      window.scrollTo(0, 0);
      this.detail = false;
      this.selectedData = {
        ID: 0,
      };
      if (params == true) {
        this.reloadData(this.params);
      }
    },
  },
};
</script>
 <style scoped>
.nonfixed {
  position: inherit;
  padding-left: 20px;
}
.core-enter-active {
  transition: all 0.3s ease;
}
.core-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.core-enter, .core-leave-to
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: translateX(10px);
  opacity: 0;
}
.core {
  -webkit-transform-origin-y: all 1s ease;
  -webkit-transition: all 1s ease;
  -moz-transition: all 1s ease;
  -o-transition: all 1s ease;
  transition: all 1s ease;
}
.vs-con-table .vs-con-tbody .vs-table--tbody-table {
  font-size: 12px;
}
.vertical-divider {
  border-right: 1px solid #7367f0;
  /* min-height: 800px; */
  /* height: 100%; */
  -webkit-mask-position-y: fixed;
  /* padding: 5px; */
}
.vs-con-table.stripe .tr-values:nth-child(2n) {
  background: beige;
}
.colored {
  border: 1px solid #7367f0;
  position: fixed;
  left: 4%;
  top: 40%;
  max-width: 45%;
  z-index: 999999999999;
  background: antiquewhite;
  background-color: antiquewhite;
}
</style>
